import Retrieval from '@/features/retrieval/components/retrieval';
import LoginDialog from '@/features/retrieval/components/retrieval-login';
import { RetrievalNavbar } from '@/features/retrieval/components/retrieval-navbar';
import { Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: RetrievalComponent
});

function RetrievalComponent() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden'
      }}
    >
      <RetrievalNavbar />
      <Box
        sx={{
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Retrieval />
      </Box>
      <LoginDialog />
    </Box>
  );
}
